"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QuickOptions_1 = require("./components/quick/QuickOptions");
exports.QuickOptions = QuickOptions_1.default;
var mountAndShowFullOptions_1 = require("./utils/mountAndShowFullOptions");
exports.mountAndShowFullOptions = mountAndShowFullOptions_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/lazyIndex.js
// module id = 2562
// module chunks = 2